<template>
  <div class="h-auto flex flex-col justify-around w-full">
    <div
      v-if="isAdmin && loggedInUser && !$route.meta.hideNavbar"
      class="flex flex-row bg-[#10A14A] py-[5px]"
    >
      <div class="text-white px-5 ml-[8px]">
        {{ $t('mycountly.dashboard.admin.you-are') }} <span class="font-semibold">{{ $t('mycountly.dashboard.admin.mode') }}</span>
      </div>
      <div class="text-white  underline cursor-pointer ml-auto mr-[20px]">
        <router-link to="/admin">
          {{ $t('mycountly.dashboard.admin.go-to') }}
        </router-link>
      </div>
    </div>
    <div
      v-if="$route.path !== '/loading' && !$route.meta.hideNavbar"
      class="sticky top-0 z-50"
      style="background-color: #1c1c1c; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;"
    >
      <header-logged-in
        class="max-w-[1400px] w-full m-auto"
      />
    </div>
    <div
      :class="[$route.meta.hideNavbar && 'h-min-screen w-min-screen bg-white', !$route.meta.hideNavbar && 'max-w-[1400px] w-full m-auto h-full']"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/stores';
import HeaderLoggedIn from './containers/header-logged-in.vue';

export default {
  name: 'DashboardLayout',
  components: {
    HeaderLoggedIn,
  },
  setup() {
    const authStore = useAuthStore();
    const { loggedInUser } = storeToRefs(authStore);
    return {
      loggedInUser,
    };
  },
  computed: {
    isAdmin() {
      if (this.loggedInUser) {
        return this.loggedInUser.isAdmin;
      } return false;
    },
  },
};
</script>
